import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Повертає callback для кнопки "назад" — завжди перехід на список сутності (listPath).
 */
export function useBackToOrList(listPath: string) {
    const navigate = useNavigate();
    return useCallback(() => {
        navigate(listPath);
    }, [navigate, listPath]);
}
